Vue.component('passwordReset', {
  props: ['error', 'success'],
  mounted() {
    if (this.error) {
      (new Notyf()).alert(this.error);
    }

    if (this.success) {
      (new Notyf()).confirm(this.success);
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/passwordReset.js